import { Edit24, Application24 } from "@carbon/icons-react";
import React, { useContext, useEffect } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ButtonSet } from "carbon-components-react";
import SubmitButton from "../../components/Buttons/SubmitButton";
import Card from "../../components/Card/Card";
import { AuthContext } from "../../contexts/AuthContext";
import http from "../../http-common";

const APPLICATION_SUBMITTED_STATUS_CODE = 2;

const CompetitorDashboardPage = () => {
  const { user } = useContext(AuthContext);
  const [application, setApplication] = useState(null);
  const [prototype, setPrototype] = useState(null);
  const navigate = useNavigate();

  const loadDashboardData = async () => {
    try {
      const response = await http.get(`/applications/load-user-application`);
      setApplication(response.data);
    } catch {}

    try {
      const protoResponse = await http.get(`/prototypes/my`);
      setPrototype(protoResponse.data);
    } catch {
      setPrototype(null);
    }
  };

  useEffect(() => {
    loadDashboardData();
  }, [user]);

  const isApplicationSubmitted =
    application?.currentStatusCode === APPLICATION_SUBMITTED_STATUS_CODE;

  return (
    <Card title={"Olá " + user.firstName + " " + user.lastName}>
      <div>
        <h5>O período de candidaturas terminou no dia 02 de Junho.</h5>
        <ButtonSet className="mt-2">
          <SubmitButton
            type="button"
            className="emprega-bg-green"
            label={
              application === null
                ? "Registar Candidatura"
                : "Consultar Candidatura"
            }
            icon={Edit24}
            onClick={() =>
              navigate(
                application === null
                  ? "../create-candidature"
                  : "../candidature/" + application.uuid,
              )
            }
          />
          {isApplicationSubmitted && (
            <SubmitButton
              type="button"
              className="emprega-bg-green"
              label={
                prototype === null
                  ? "Registar Protótipo"
                  : prototype.prototypeStatus === "SUBMITTED"
                  ? "Consultar Protótipo"
                  : "Editar Protótipo"
              }
              icon={Application24}
              onClick={() => navigate("../prototype")}
            />
          )}
        </ButtonSet>
      </div>
    </Card>
  );
};

export default CompetitorDashboardPage;
